import $http from "@/plugins/axios.js";

export default {
  state: {
    card: null,
    message: null,
    messageFaild: 0,
    isAlterCard: false,
    exchangeState: null,
  },
  getters: {
    card: (state) => state.card,
    message: (state) => state.message,
    messageFaild: (state) => state.messageFaild,
    exchangeState: (state) => state.exchangeState,
  },
  mutations: {
    SET_CARD(state, data) {
      state.card = data;
    },
    SET_MESSAGE(state, data) {
      state.message = data;
    },
    SET_MESSAGE_FAILD(state, data) {
      state.messageFaild = data;
    },
    SET_EXCHANGE_STATE(state, data) {
      state.exchangeState = data;
    },
  },
  actions: {
    async getCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`store/cards/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", null);
        throw err;
      }
    },
    async getExchangeCard({ commit, dispatch }, id) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.get(`store/cards/exchange/${id}`);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم استبدال الحساب بنجاح",
          duration: 6,
        });
        dispatch("toggleBtnLoading", false);
        commit("SET_EXCHANGE_STATE", res.data.success);
      } catch (err) {
        if (err.response.status === 401) {
          dispatch("pushAlert", {
            alertVariant: "warning",
            alertMessage:
              "الحساب يعمل ولا يحتاج الى الاستبدال, في حال وجود مشكلة تواصل معنا عبر الواتساب",
            duration: 6,
          });
        }
        dispatch("toggleIsLoading", false);
        commit("SET_EXCHANGE_STATE", err.response.data.success);
        throw err;
      }
    },
    async getAlterCard({ commit, dispatch }, id) {
      dispatch("toggleIsLoading", true);
      try {
        const res = await $http.get(`store/gmail/${id}`);
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", res.data.data);
      } catch (err) {
        dispatch("toggleIsLoading", false);
        commit("SET_CARD", null);
        throw err;
      }
    },
    setMessageFaild({ commit }, payload) {
      commit("SET_MESSAGE_FAILD", payload);
    },
    async getMessage({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        const res = await $http.post("/email", payload);
        dispatch("toggleBtnLoading", false);
        commit("SET_MESSAGE", res.data.data);
      } catch (err) {
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          if (localStorage.getItem("messageFaild")) {
            localStorage.setItem(
              "messageFaild",
              JSON.parse(localStorage.getItem("messageFaild")) + 1
            );
            commit(
              "SET_MESSAGE_FAILD",
              JSON.parse(localStorage.getItem("messageFaild"))
            );
          } else {
            localStorage.setItem("messageFaild", 0);
          }
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
  },
};
